<template>
  <DefaultLayout
    :pageProps="{
      title: 'Final step: Check your email and verify your account',
    }"
  >
    <template #content>
      <div style="display: flex; flex-direction: column; gap: 16px">
        <div class="subtitle">
          We've sent you a verification email to
          <b>{{ email }}</b>
        </div>
        <SubmitButton
          text="Resend verification email"
          id="resendVerificationEmail"
          :loading="loading"
          @click.native="resendVerificationEmail"
        />
      </div>

      <ToastSuccess text="Verification email was sent!" />
      <ToastError
        text="There was a problem sending an email. Please try again later."
      >
        <template>
          <div>Error: {{ toastMessage }}</div>
        </template>
      </ToastError>
    </template>
  </DefaultLayout>
</template>

<script>
import SubmitButton from "@/components/buttons/SubmitButton";
import { logging } from "@/api/logs";
import { mix_panel } from "@/services/common/mixpanel";
import { verification } from "@/services/verification";
import { store } from "@/store";
import { email_sender_constants } from "@/services/common/constants";
import ToastSuccess from "@/components/toast/ToastSuccess";
import ToastError from "@/components/toast/ToastError";
import DefaultLayout from "../../layout/DefaultLayout.vue";

export default {
  name: "index",
  components: { DefaultLayout, ToastError, ToastSuccess, SubmitButton },
  data() {
    return {
      email: "",
      loading: false,
    };
  },
  async mounted() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
      store.commit("auth/updateEmail", this.email);
    }

    if (this.$route.query.resend) {
      await this.resendVerificationEmail();
    }
  },
  methods: {
    async resendVerificationEmail() {
      if (this.loading) {
        return;
      }

      logging.sendLog("Verification Email requested", 3);
      await mix_panel.onBasicEvent("VerificationEmailRequested", "");
      this.loading = true;

      try {
        await verification.resendEmail(store.state.auth.email, "verify");
        this.$bvToast.show("toast-success");
      } catch (e) {
        logging.sendLog("Verification email was not sent!", 6);
        this.toastMessage = email_sender_constants.NOT_SENT;
        this.$bvToast.show("toast-error");
      }

      this.loading = false;
    },
  },
};
</script>
